export const webhookPayloadTextExample = `{
  "content": "ola\\ntudo bem,\\ncom voce?",
  "instance_id": "instance_demo",
  "chat_id": "chat_123",
  "phone_number": "5511000000000",
  "phone_sender": "5511999999999",
  "partial_messages": [
    {
      "text_content": "ola",
      "message_type": "text"
    },
    {
      "text_content": "tudo bem,",
      "message_type": "text"
    },
    {
      "text_content": "com voce?",
      "message_type": "text"
    }
  ]
}`;

export const webhookPayloadWithImageExample = `{
  "content": "O cliente enviou uma imagem. Transcrição: **Descrição da Imagem:** Exemplo de imagem enviada pelo cliente.\\n\\n**Textos Extraídos:** \\nDocumento de exemplo  \\nValor total: R$ 0,00  \\nData de emissão: 01/01/2024  \\nURL da imagem: https://example.com/media/arquivo.jpg.",
  "instance_id": "instance_demo",
  "chat_id": "chat_456",
  "phone_number": "5511000000000",
  "phone_sender": "5511999999999",
  "partial_messages": [
    {
      "text_content": "",
      "message_type": "image",
      "media_url": "https://example.com/media/arquivo.jpg",
      "media_transcription": "**Descrição da Imagem:** Exemplo de imagem enviada pelo cliente.\\n\\n**Textos Extraídos:** \\nDocumento de exemplo  \\nValor total: R$ 0,00  \\nData de emissão: 01/01/2024"
    }
  ]
}`;
